import { EmailValidator, PhoneValidator } from '../../../../../../utilities/commonValidators'

export const validate = (values) => {
  const errors = {}

  /* First Name */
  if (!values.firstName) {
    errors.firstName = 'Required'
  } else if (values.firstName.length > 100) {
    errors.firstName = 'First Name must be less than 100 characters'
  }

  /* Last Name */
  if (!values.lastName) {
    errors.lastName = 'Required'
  } else if (values.lastName.length > 100) {
    errors.lastName = 'Last Name must be less than 100 characters'
  }

  /* Email */
  if (!values.email) {
    errors.email = 'Required'
  } else if (values.email.length >= 64) {
    errors.email = 'Email cannot be more than 64 characters'
  } else if (!EmailValidator.test(values.email)) {
    errors.email = 'Invalid email'
  }

  /* Primary Phone */
  if (!values.prettyPrimaryPhone) {
    errors.prettyPrimaryPhone = 'Required'
  } else if (!PhoneValidator(values.prettyPrimaryPhone)) {
    errors.prettyPrimaryPhone = 'Invalid Phone Number'
  }

  /* Role */
  if (!values.role) {
    errors.role = 'Required'
  }

  return errors
}
